import { Button } from 'antd';

import type { LeadCardActionButtonItemData } from '@app/components/LeadCard/data';

import type { FC } from 'react';

import './ActionButtons.scss';

interface ActionButtonsProps {
  actions: LeadCardActionButtonItemData[];
}

export const ActionButtons: FC<ActionButtonsProps> = ({ actions }) => {
  if (actions.length === 0) {
    return null;
  }

  return (
    <div className="ActionButtons">
      {actions.map(
        ({ id, priority, danger, disabled, isLoading, label, onClick }) => (
          <Button
            className="ActionButtons__button"
            type={priority ? 'primary' : 'default'}
            danger={danger}
            disabled={disabled}
            loading={isLoading}
            onClick={onClick}
            size="small"
            key={id}
          >
            {label}
          </Button>
        )
      )}
    </div>
  );
};
